import { DownloadSimple, PaperPlaneTilt, X } from "@phosphor-icons/react";

interface SelectionBarProps {
  count: number;
  onClear: () => void;
  onSendToReview: () => void;
  onDownload: () => void;
}

export function SelectionBar({
  count,
  onClear,
  onSendToReview,
  onDownload,
}: SelectionBarProps) {
  if (count === 0) return null;

  return (
    <div
      role="region"
      aria-label="Selected videos"
      className="opella-selection-bar fixed bottom-6 left-1/2 z-40 flex items-center gap-4 rounded-full px-5 py-3"
      style={{
        transform: "translateX(-50%)",
        background: "var(--opella-fg)",
        color: "#ffffff",
        boxShadow: "var(--opella-shadow-elevated)",
      }}
    >
      <span
        className="flex items-center gap-2 rounded-full px-3 py-1 text-sm font-semibold"
        style={{
          background: "var(--opella-accent)",
        }}
      >
        <span className="tabular-nums">{count}</span>
        <span>selected</span>
      </span>

      <div
        className="h-5 w-px"
        style={{ background: "rgba(255,255,255,0.18)" }}
        aria-hidden
      />

      <button
        type="button"
        onClick={onSendToReview}
        className="flex items-center gap-2 rounded-full px-4 py-1.5 text-sm font-semibold transition-colors"
        style={{
          background: "#ffffff",
          color: "var(--opella-fg)",
        }}
      >
        <PaperPlaneTilt size={16} weight="fill" aria-hidden />
        Send to Puntt review
      </button>

      <button
        type="button"
        onClick={onDownload}
        className="flex items-center gap-2 rounded-full px-4 py-1.5 text-sm font-medium"
        style={{
          color: "#ffffff",
          border: "1px solid rgba(255,255,255,0.24)",
        }}
      >
        <DownloadSimple size={16} weight="bold" aria-hidden />
        Download
      </button>

      <button
        type="button"
        onClick={onClear}
        aria-label="Clear selection"
        className="flex size-8 items-center justify-center rounded-full"
        style={{
          background: "rgba(255,255,255,0.08)",
          color: "#ffffff",
        }}
      >
        <X size={14} weight="bold" aria-hidden />
      </button>
    </div>
  );
}
